import React from 'react';
import { FaMapMarkerAlt, FaCar, FaRupeeSign, FaClock, FaRoute, FaArrowRight } from 'react-icons/fa';
import './PopularDestinations.css';

const PopularDestinations = ({ onBookNow }) => {
  const popularRoutes = [
    {
      id: 'chennai-madurai',
      from: 'Chennai',
      to: 'Madurai',
      distance: '460',
      price: '6440',
      originalPrice: '7950',
      savings: '1510',
      image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-trichy',
      from: 'Chennai',
      to: 'Trichy',
      distance: '320',
      price: '4480',
      originalPrice: '5600',
      savings: '1120',
      image: 'https://images.unsplash.com/photo-1564507592333-c60657eea523?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-thanjavur',
      from: 'Chennai',
      to: 'Thanjavur',
      distance: '350',
      price: '4900',
      originalPrice: '6125',
      savings: '1225',
      image: 'https://images.unsplash.com/photo-1548013146-72479768bada?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-kumbakonam',
      from: 'Chennai',
      to: 'Kumbakonam',
      distance: '290',
      price: '4060',
      originalPrice: '5075',
      savings: '1015',
      image: 'https://images.unsplash.com/photo-1599661046827-dacde6976549?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-salem',
      from: 'Chennai',
      to: 'Salem',
      distance: '340',
      price: '4760',
      originalPrice: '5950',
      savings: '1190',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-coimbatore',
      from: 'Chennai',
      to: 'Coimbatore',
      distance: '500',
      price: '7000',
      originalPrice: '8750',
      savings: '1750',
      image: 'https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-bangalore',
      from: 'Chennai',
      to: 'Bangalore',
      distance: '350',
      price: '4900',
      originalPrice: '6125',
      savings: '1225',
      image: 'https://images.unsplash.com/photo-1570168007204-dfb528c6958f?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-tiruvannamalai',
      from: 'Chennai',
      to: 'Tiruvannamalai',
      distance: '195',
      price: '2730',
      originalPrice: '3415',
      savings: '685',
      image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-tirunelveli',
      from: 'Chennai',
      to: 'Tirunelveli',
      distance: '630',
      price: '8820',
      originalPrice: '11025',
      savings: '2205',
      image: 'https://images.unsplash.com/photo-1548013146-72479768bada?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-karaikudi',
      from: 'Chennai',
      to: 'Karaikudi',
      distance: '410',
      price: '5740',
      originalPrice: '7175',
      savings: '1435',
      image: 'https://images.unsplash.com/photo-1599661046827-dacde6976549?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-pudukottai',
      from: 'Chennai',
      to: 'Pudukottai',
      distance: '380',
      price: '5320',
      originalPrice: '6650',
      savings: '1330',
      image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=300&h=200&fit=crop'
    },
    {
      id: 'chennai-pondicherry',
      from: 'Chennai',
      to: 'Pondicherry',
      distance: '160',
      price: '2240',
      originalPrice: '2800',
      savings: '560',
      image: 'https://images.unsplash.com/photo-1582510003544-4d00b7f74220?w=300&h=200&fit=crop'
    }
  ];

  const handleBookNow = (route) => {
    // Create WhatsApp message with route details
    const message = `Hi! I would like to book a taxi for the following route:

📍 From: ${route.from}
📍 To: ${route.to}
📏 Distance: ${route.distance} km
💰 Price: ₹${route.price}
🚗 Trip Type: One Way

Note: Driver Bata, Toll fees, hills charges, Parking charges and Inter-State Permit charges (if any) are extra.

Please confirm availability and provide booking details.

Thank you!`;

    // Encode the message for URL
    const encodedMessage = encodeURIComponent(message);
    
    // WhatsApp number (same as used in other components)
    const phoneNumber = '917200085345';
    
    // Create WhatsApp URL
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodedMessage}`;
    
    // Open WhatsApp in new tab
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div id="popular-destinations" className="popular-destinations">
      <div className="destinations-container">
        <div className="section-header">
          <div className="header-icon">
            <FaRoute />
          </div>
          <div className="header-content">
            <h2 className="destinations-title">Popular Taxi Routes from Chennai</h2>
            <p className="destinations-subtitle">Best One Way Drop Taxi Service in Tamilnadu Low Cost Drop Taxi Chennai</p>
          </div>
        </div>
        
        <div className="routes-grid">
          {popularRoutes.map((route) => (
            <div key={route.id} className="premium-route-card">
              <div className="card-header">
                <h3 className="route-title">{route.from} to {route.to} One Way Taxi | Affordable Drop Taxi Service</h3>
                <div className="distance-info">
                  <span className="distance">{route.distance} KMs</span>
                  <span className="asterisk">*</span>
                </div>
              </div>
              
              <div className="card-body">
                <div className="service-details">
                  <h4 className="service-title">{route.distance} kms </h4>
                  <p className="service-description">
                    Extra km 14/KM after {route.distance} kms,Driver batta, Toll as applicable
                  </p>
                </div>
                
                <div className="pricing-section">
                  <div className="price-row">
                    <div className="current-price">
                      <span className="currency">Rs</span>
                      <span className="amount">{route.price}</span>
                      <span className="price-type">*</span>
                    </div>
                    <div className="original-price">
                      <span className="crossed-price">Rs {route.originalPrice}</span>
                    </div>
                  </div>
                  <div className="trip-type">Onwards</div>
                </div>
              </div>
              
              <div className="card-footer">
                <button 
                  className="premium-book-btn"
                  onClick={() => handleBookNow(route)}
                >
                  BOOK NOW
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PopularDestinations;